import React, { useEffect, useLayoutEffect, useState } from "react";
import { Select, Button, Menu, Input, DatePicker, Tag, Dropdown, Table, Modal } from "antd";
import {
    AppstoreOutlined, LinkOutlined, SwitcherOutlined, WalletOutlined, SearchOutlined, FilterOutlined, SortDescendingOutlined, EyeOutlined, EditOutlined,
    LockOutlined, CloseOutlined, MoreOutlined, CheckCircleOutlined,
    EllipsisOutlined,
    CheckOutlined
} from "@ant-design/icons";
import { Col, Row } from 'reactstrap';
import TransactionModal from "./DetailModal";
import { useMutation } from "react-query";
import dayjs from "dayjs";
import '../utils/transaction.css';
import { getBusinessAccount, getTransactionsOfBusinessAccount, getPaymentMethodsByCountry } from "../services/api";



const Transactions = () => {

    // Variable de session
    const currentUser = JSON.parse(sessionStorage.getItem('authUser'));

    // Variables d'état
    const [current, setCurrent] = useState('all');
    const [businessAccount, setBussinessAccount] = useState([]);
    const [defaultBusiness, setDefaultBusiness] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [operatorFilter, setOperatorFilter] = useState("");
    const [dateFilter, setDateFilter] = useState(dayjs());
    const [filteredTransactions, setFilteredTransactions] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [selectedBusiness, setSelectedBusiness] = useState(null);

    // Mutations
    const businessAccountMutation = useMutation(getBusinessAccount);
    const businessAccountTransactionsMutation = useMutation(getTransactionsOfBusinessAccount);
    const paymentMethodsMutattion = useMutation(getPaymentMethodsByCountry);

    const formatDateFromArray = (dateArray) => {
        if (!dateArray || dateArray.length < 3) return ""; // Vérifie si la date est valide
        const [year, month, day] = dateArray;
        return dayjs(`${year}-${month}-${day}`).format("YYYY-MM-DD"); // Ajoute +1 au mois car en JS, janvier = 0
    };





    // Getting all business accounts of this user
    useEffect(() => {
        const requestData = {
            userId: currentUser.user.id,
            token: currentUser.token
        }
        businessAccountMutation.mutate(requestData, {
            onSuccess: (response) => {
                setBussinessAccount(response);
                setDefaultBusiness(response[0].id);
                setSelectedBusiness(response[0].businessName);
                localStorage.setItem("businessId", response[0].id);
                localStorage.setItem("businessApiKey", response[0].apiKey);
                localStorage.setItem("businessApiToken", response[0].apiToken);
            },
            onError: (error) => {
                console.error(error);
            }
        })
    }, []);


    // Getting transaction of business account
    useEffect(() => {
        getTransactions();
    }, [selectedBusiness]);


    // Getting all payment methods
    useEffect(() => {
        getPaymentMethods();
    }, []);

    const getTransactions = () => {
        const requestData = {
            businessId: localStorage.getItem("businessId"),
            token: currentUser.token
        }
        let transactionTemp = [];
        businessAccountTransactionsMutation.mutate(requestData, {
            onSuccess: (response) => {
                if (transactionTemp != null) {
                    transactionTemp = response.data;
                    setTransactions(transactionTemp.reverse());
                    setFilteredTransactions(transactionTemp.reverse());
                }
            },
            onError: (error) => {
                console.error(error);
            }
        })
    }

    const getPaymentMethods = () => {
        const requestData = {
            token: currentUser.token
        }

        paymentMethodsMutattion.mutate(requestData, {
            onSuccess: async (response) => {
                // // await response.map((country) => {
                // //     country.paymentMethod.map((methodPayment) => {
                // //         setPaymentMethods((prevPaymentMethods) => [...prevPaymentMethods, methodPayment]);
                // //     })
                // });
                let paymentMethodsTemp = [];
                await response.map((paymentMethod) => {
                    paymentMethodsTemp.push({
                        id: paymentMethod.id,
                        name: `${paymentMethod.name} (${paymentMethod.country})`
                    });
                });
                setPaymentMethods(paymentMethodsTemp);
            },
            onError: (error) => {
                console.error(error);
            }
        })
    }

    const firstFilterTransactions = (status) => {
        const filtered = transactions.filter(transaction => {
            const statusMatch = status ? transaction.status === status : true;
            return statusMatch;
        });
        setFilteredTransactions(filtered);
    }

    // Filtrer les transactions, le deuxième filtre.
    const filterTransactions = () => {
        const filtered = transactions.filter(transaction => {
            // Vérifie si le statut correspond
            const operatorMatch = operatorFilter ? transaction.paymentMethod === operatorFilter : true;

            // Vérifie si la date correspond
            const dateMatch = dateFilter ? dayjs(transaction.createdAt).isSame(dateFilter, 'day') : true;

            return operatorMatch && dateMatch;
        });

        setFilteredTransactions(filtered);
    };

    // Filtre de recherche
    const handleSearch = (e) => {
        setSearchText(e.target.value.toLowerCase());
        const filteredData = transactions.filter((item) => Object.values(item).some((val) => String(val).toLowerCase().includes(e.target.value.toLowerCase())));
        setFilteredTransactions(filteredData);
    }

    // Le gestionnaire du menu des types
    const onClickMenu = (e) => {
        setCurrent(e.key);
        if (e.key == "success") {
            //setStatusFilter("SUCCESS");
            firstFilterTransactions("SUCCESS");
        } else if (e.key == "echecs") {
            //setStatusFilter("REJECTED");
            firstFilterTransactions("REJECTED");
        } else if (e.key == "attentes") {
            //setStatusFilter("REJECTED");
            firstFilterTransactions("PENDING");
        } else {
            getTransactions();
        }
    }

    const openDetailsModal = (record) => {
        setSelectedTransaction(record)
        setIsModalOpen(true);
    }




    const itemsMenu = [
        {
            label: <p className="menu-options">Toutes les transactions</p>,
            key: 'all',
            icon: <AppstoreOutlined />,
        },
        {
            label: <p className="menu-options">Succès</p>,
            key: 'success',
        },
        {
            label: <p className="menu-options">Échecs</p>,
            key: 'echecs',
        },
        {
            label: <p className="menu-options">Attentes</p>,
            key: 'attentes',
        }
    ];

    const columns = [
        {
            title: "ID de la transaction",
            dataIndex: "transactionId",
            key: "description",
            render: (id) => <span className="menu-options">{id}</span>
        },
        {
            title: "Date de création",
            dataIndex: "createdAt",
            key: "date",
            render: (timestamp) => new Date(timestamp).toLocaleString('fr-FR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            })

        },
        {
            title: "Opérateurs",
            dataIndex: "paymentMethod",
            key: "paymentMethod",
            align: "right",
        },
        {
            title: "Montant encaissé",
            key: "amount",
            align: "right",
            render: (record) => <Tag color="default">{record.amount} {record.currency}</Tag>
        },
        {
            title: "Statut",
            dataIndex: "status",
            key: "status",
            render: (status) => {
                if (status == "SUCCESS") {
                    return (
                        <div className="status-active-transactions">
                            <span style={{ color: "green" }}>✔️</span>
                            <span className="text-status-transactions"> {status} </span>
                        </div>)
                } else if (status == "REJECTED") {
                    return (
                        <div className="status-blocked-transactions">
                            <span className="text-status-transactions">❌ {status} </span>
                        </div>)
                } else if (status == "PENDING") {
                    return (
                        <div className="status-pending-transactions">
                            <LockOutlined className="status-icon" />
                            <span className="text-status-transactions"> {status} </span>
                        </div>)
                }

            },
        },
        {
            title: "Action",
            key: "action",
            render: (record) => (
                <Button type="text" style={{ fontSize: '15px', color: "#3761FF", backgroundColor: "#F2F5FF", borderRadius: '5%', fontWeight: 'bolder' }} onClick={() => openDetailsModal(record)}>
                    Consulter
                </Button>
            ),
        },
    ];


    return (
        <div>
            <div>
                <h3 className="col-10 col-md-6 mt-4"> Historique des transactions </h3>
                <div className="d-flex justify-content-between col-12 col-md-4">
                    {
                        businessAccount.length > 0 && (
                            <>
                                <Select
                                    onChange={(value) => {
                                        businessAccount.forEach((business) => {
                                            if (business.id == value) {
                                                localStorage.setItem("businessId", value);
                                                localStorage.setItem("businessApiKey", business.apiKey);
                                                localStorage.setItem("businessApiToken", business.apiToken);
                                                setSelectedBusiness(business.businessName);
                                                const requestData = {
                                                    token: currentUser.token
                                                }
                                            }
                                        });
                                    }}
                                    className="business-account-select-transactions col-md-9"
                                    defaultValue={defaultBusiness}
                                    options={businessAccount.map((business) => ({
                                        value: business.id,
                                        label: business.businessName,
                                    }))}
                                />
                                <Button type="primary" style={{ height: '40px', backgroundColor: '#3761FF' }}><span className="menu-options">Consulter</span></Button>
                            </>
                        )

                    }

                </div>

            </div>
            <div className="mt-3">
                <Menu selectedKeys={[current]} mode="horizontal" items={itemsMenu} onClick={onClickMenu} />
                <div className="d-flex justify-content-around col-12 mt-2">
                    <Input
                        placeholder="Rechercher"
                        className="square-select col-12 col-md-3"
                        size="large" prefix={<SearchOutlined style={{ color: "rgba(0,0,0,0.45)" }} />}
                        value={searchText}
                        onChange={handleSearch}
                    />
                    <div className="d-none d-md-flex col-md-7 filter-options">
                        <Select
                            placeholder="Opérateur"
                            className="select-filter d-none d-md-block"
                            size="large"
                            onChange={(value) => setOperatorFilter(value)}
                            options={paymentMethods.map(method => ({
                                value: method.id,
                                label: method.name
                            }))}
                        />
                        <DatePicker defaultValue={dayjs()} format="YYYY-MM-DD" onChange={(date) => setDateFilter(date)} style={{ borderRadius: '0', width: '20%' }} placeholder="Selectionner une date" className="d-none d-md-block"/>
                        <Button size="large" icon={<FilterOutlined />} style={{ color: "#3761FF" }} color="primary" variant="outlined" onClick={filterTransactions} className="d-none d-md-block">
                            Filtrer
                        </Button>
                    </div>
                    <Button size="large" icon={<SortDescendingOutlined />} style={{ color: "#3761FF" }} color="primary" variant="outlined" className="d-none d-md-block col-md-1">
                        Trier
                    </Button>
                </div>
                <div>
                    <Table columns={columns} dataSource={filteredTransactions} pagination={true} scroll={{x: true}} className="mt-3"/>
                </div>
                
            </div>

            <TransactionModal visible={isModalOpen} onClose={() => setIsModalOpen(false)} transaction={selectedTransaction} business={selectedBusiness} />
        </div>
    )
}

export default Transactions;